import { useEffect, useMemo, useState } from 'react';
import KickImage from 'Reuseables/KickImage';

interface IUseMakeInfiniteScrollProps {
  dataSource: any[];
  perPage?: number;
}

export const useMakeInfiniteScroll = ({
  dataSource,
  perPage = 10,
}: IUseMakeInfiniteScrollProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<any[]>([]);
  const [paginationPage, setPaginationPage] = useState<number>(1);

  const totalPage = useMemo(() => {
    if (!dataSource.length) {
      return 0;
    }

    return dataSource.length / (perPage || 10);
  }, [dataSource, perPage]);

  const hasMoreData = useMemo(() => {
    return paginationPage < totalPage;
  }, [paginationPage, totalPage]);

  const loadMore = () => {
    if (hasMoreData) {
      setPaginationPage((prev) => prev + 1);
    }
  };

  const refresh = () => {
    setPaginationPage(1);
    setData([]);
  };

  useEffect(() => {
    setIsLoading(true);
    const startIndex = perPage * (paginationPage - 1);
    const endIndex = startIndex + perPage;
    const newData = dataSource.slice(startIndex, endIndex);

    setTimeout(() => {
      setData((prevData) => [...prevData, ...newData]);
      setIsLoading(false);
    }, 1000);
  }, [paginationPage]);

  return {
    isLoading,
    data,
    totalPage,
    hasMoreData,
    loadMore,
    refresh,
  };
};
